<div class="footer-wrapper" fxFlex style="background: #1d4d8e;padding: 2em ">
  <div *ngIf="!isUAERoute" class="footer-container" fxFlex fxLayout="row" fxLayout.lt-md="row wrap" fxLayoutAlign=" center" style="width: 80%;align-self: center;color:white">
    <div *ngIf="localeService.israeliMarket" class="footer-address" fxLayout="column" fxFlex="30" fxFlex.lt-md="100" fxLayoutGap="1em">
      <div class="main-address" fxLayout="row" fxLayoutGap=".5em"  fxFlex.lt-md="100" fxLayoutAlign=" center">
        <span fxFlex="15">{{ 'FOOTER.ADDRESS_LABEL' | translate }}</span>
        <span>{{ 'FOOTER.ADDRESS_VALUE' | translate }}</span>
        <mat-icon svgIcon="fi_map"></mat-icon>
      </div>
      <div class="business-phone" fxLayout="row"  fxFlex.lt-md="100" fxLayoutGap=".5em">
        <span fxFlex="15">{{ 'FOOTER.PHONE_LABEL' | translate }}</span>
        <span><a href="tel://972506880102">0506880102</a></span>
        <mat-icon svgIcon="fi_phone"></mat-icon>
      </div>
    </div>
    <div class="footer-copyrights" fxLayout="column" fxFlex.lt-md="100" fxFlex="30">
      <span>{{ 'FOOTER.COPYRIGHT' | translate }}</span>
<!--      <span>Echo-dev Web development</span>-->
    </div>
    <div class="footer-menu" fxFlex.lt-md="100" fxFlex="30" >
      <div class="f-menu" fxLayout="row" fxLayoutAlign="space-evenly">
        <a routerLink="/contact">{{ 'FOOTER.CONTACT_US' | translate }}</a>
        <a routerLink="/faq">{{ 'FOOTER.FAQ' | translate }}</a>
        <a *ngIf="localeService.israeliMarket" routerLink="/terms">{{ 'FOOTER.SITE_TERMS' | translate }}</a>
      </div>
    </div>
  </div>
</div>
